import React from 'react'

const Attachment = ({
  size,
  style,
  primaryColor,
  secondaryColor,
  title = 'icon/attachment',
  ...props
}) => (
  <svg height='20' width='20' viewBox='0 0 20 20' style={style} {...props}>
    <path
      d='M14.47 6.155l.03 7.572c0 3.35-1.625 5.273-4.457 5.273-4.098 0-4.542-3.69-4.543-5.277l.02-9.548C5.52 2.304 6.5 1 8.413 1c1.89 0 3.207 1.185 3.207 3.112l-.018 9.609c0 .948-.29 2.08-1.56 2.08-1.367 0-1.646-1.13-1.647-2.08l.018-9.588'
      fill='none'
      fillRule='evenodd'
      stroke={primaryColor}
      strokeLinecap='round'
      strokeWidth='1.2'
    />
  </svg>
)

export default Attachment
